import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth/auth' // авторизация
import setting from './modules/profile/settings' // настройки профиля
import request from './modules/bot/request' // страница запросы в ботах

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    language: 'ru',
    headers: { "Authorization": auth.state.token },
    loader: false,
    countMessage: 0,
  },
  mutations: {},
  actions: {},
  getters: {},
  modules: {
    auth, setting, request
  }
});
